export const REQUIRED = 'REQUIRED';
export const OPTIONAL = 'OPTIONAL';
export const HIDDEN = 'HIDDEN';
export const INTERNAL = 'INTERNAL';
